// Service mark for the EMBI brand term. U+2120 (℠) is already a superscript
// "SM" glyph by design, so we render the bare character — no wrapper span or
// vertical-align (those break inline text flow/wrapping).
export const SM = () => <>℠</>;
